import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import Testimonials from '../testimonials/testimonials';
import './expandable_block.css';

var ExpandableBlock = function (_Component) {
	_inherits(ExpandableBlock, _Component);

	function ExpandableBlock() {
		_classCallCheck(this, ExpandableBlock);

		var _this = _possibleConstructorReturn(this, (ExpandableBlock.__proto__ || Object.getPrototypeOf(ExpandableBlock)).call(this));

		_this.state = {
			open: false
		};

		_this.toggleBlock = _this.toggleBlock.bind(_this);
		return _this;
	}

	_createClass(ExpandableBlock, [{
		key: 'toggleBlock',
		value: function toggleBlock() {
			this.setState({ open: !this.state.open });
		}
	}, {
		key: 'render',
		value: function render() {
			var _props$block = this.props.block,
			    title = _props$block.title,
			    content = _props$block.content,
			    testimonials = _props$block.testimonials;
			// TODO - if no testimonials make sure the title is not displayed

			return React.createElement(
				'div',
				{ className: 'expandable-block wrapper-small ' + (this.state.open ? 'open' : 'closed') + ' ' },
				React.createElement(
					'div',
					{ className: 'title', onClick: this.toggleBlock },
					React.createElement(
						'h2',
						null,
						title
					)
				),
				this.state.open && content && React.createElement(
					'p',
					{ className: 'content' },
					content
				),
				this.state.open && testimonials && React.createElement(Testimonials, {
					testimonials: this.props.testimonials
				})
			);
		}
	}]);

	return ExpandableBlock;
}(Component);

export default ExpandableBlock;